import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private reloadStatisticsListener = new Subject<any>();

  constructor() { }

  public listenReloadStatistics() {
    return this.reloadStatisticsListener.asObservable();
  }

  public reloadStatistics(centers, from, to) {
    this.reloadStatisticsListener.next({centers, from, to});
  }
}
